export default __webpack_public_path__ + "static/PC_5-5d2de14bb7ada2dd32759acaed3f7bc1.png";